// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"cff3e17e","918":"a180f561"}[chunkId] + ".chunk.css";
};